// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2VqJ8","title":"Header_title__3XSy-","side":"Header_side__IPlsR"};